import _slicedToArray from "/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState, useCallback, useRef } from "react";
import { initStorageNamespace } from "../StorageHandler";
export { initStorageNamespace };

var useHandler = function useHandler(namespace, version, options) {
  var handlerRef = useRef();
  var curHandler = handlerRef.current;

  if (!curHandler || curHandler.namespace !== namespace || curHandler.version !== version) {
    curHandler = handlerRef.current = initStorageNamespace(namespace, version, options);
  }

  if (!curHandler.cacheValidated) curHandler.checkCache();
  return curHandler;
};

export var useLocalStorage = function useLocalStorage() {
  var namespace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var handlerInstance = useHandler(namespace, version, options);
  var useStorageKey = useCallback(function (key, defaultValue, validate) {
    if (typeof key !== "string" || key === "") return console.error("useLocalStorage hook called without a proper key value");

    if (typeof defaultValue === "undefined") {
      throw new Error("Trying to set undefined value to state of item");
    }

    var keyHandler = handlerInstance.getKeyHandler(key, defaultValue, validate || function () {
      return true;
    });

    var _useState = useState(function () {
      return keyHandler.get();
    }),
        _useState2 = _slicedToArray(_useState, 2),
        get = _useState2[0],
        set = _useState2[1];

    var setValue = useCallback(function (x) {
      set(function (curState) {
        var valueToStore = x instanceof Function ? x(curState) : x;

        try {
          keyHandler.set(valueToStore);
        } catch (e) {
          if (e.code === "CACHE_INVAL") {
            return curState;
          }

          throw e;
        }

        return valueToStore;
      });
    }, [keyHandler]);
    return [get, setValue, key];
  }, [handlerInstance]);
  var useStorageListener = useCallback(function (signal, handler) {
    var signalHandler = useRef();
    if (typeof window === "undefined") return;
    var curHandler = signalHandler.current;

    if (curHandler !== handler) {
      signalHandler.current = handler;
      if (curHandler) handlerInstance.off(signal, handler);
      handlerInstance.on(signal, handler);
    }
  }, [handlerInstance]);
  return {
    useStorageKey: useStorageKey,
    useStorageListener: useStorageListener,
    storageHandler: handlerInstance
  };
};